import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'detail',
  templateUrl: './detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryDetailComponent implements OnInit {
  @Input() data;
  @Output() detailEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.detailEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.detailEmitter.emit({ status: 'backward' });
  }
}
